import React from 'react';
import {
  Autocomplete,
} from '@mui/material';
import { TokenAwareTextField as TextField } from './TokenAwareTextField';

/**
 * Shared MUI field widgets used across the builder's row editors. Presentational only — they hold no
 * campaign state and issue no writes; the parent owns the value and decides when to persist.
 */

/**
 * A freeSolo "slot / role" picker: the caller supplies the known/suggested slot names as `options`, but
 * any typed value is accepted (the runner keys on the raw string). Used verbatim by both the file-slot
 * editor (`StepFilesFields`) and the question-slot editor (`StepQuestionsFields`); they differ only in
 * their suggestion list and helper text, so those are props. `onChange` fires on input change (not just
 * selection) so a hand-typed slot is captured as the admin types.
 */
export function SlotAutocomplete(props: {
  value: string;
  options: string[];
  onChange: (value: string) => void;
  helperText: string;
  label?: string;
  disabled?: boolean;
  minWidth?: number;
}): JSX.Element {
  const { value, options, onChange, helperText, label = 'Slot', disabled, minWidth = 160 } = props;
  return (
    <Autocomplete
      freeSolo
      size="small"
      options={options}
      value={value ?? ''}
      disabled={disabled}
      onInputChange={(_e, v) => onChange(v)}
      renderInput={(params) => (
        <TextField {...params} label={label} helperText={helperText} />
      )}
      sx={{ minWidth }}
    />
  );
}

export default SlotAutocomplete;
